import { render, staticRenderFns } from "./ProvisionalRemedyRequest.vue?vue&type=template&id=055def20&scoped=true"
import script from "./ProvisionalRemedyRequest.vue?vue&type=script&lang=js"
export * from "./ProvisionalRemedyRequest.vue?vue&type=script&lang=js"
import style0 from "./ProvisionalRemedyRequest.vue?vue&type=style&index=0&id=055def20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055def20",
  null
  
)

export default component.exports